import { mediaQuery } from 'constants/ui';

export const getRowCellStyles = ({ status, ConditionStatus }) => {
  if (status === ConditionStatus.REJECTED) {
    return {
      backgroundColor: ({ palette }) => palette.error.soft,
    };
  }

  return null;
};

export const messageCellStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

const EXPANDED_ROW_PADDING_Y = 2;
const EXPANDED_ROW_PADDING_X = 4;

export const expandedRowContentStyles = {
  padding: ({ spacing }) => spacing(EXPANDED_ROW_PADDING_Y, EXPANDED_ROW_PADDING_X),
  backgroundColor: ({ palette }) => palette.background.default,
};

export const expandToggleStyles = {
  padding: 0,
};

export const conditionsTableStyles = {
  '.table': {
    minWidth: '760px',
    [mediaQuery.mobile]: {
      minWidth: '0',
    },
  },
};
